import { TRIFECTA_START_PAGE_COMPONENT_TOKEN } from '@cgs/provider-trifecta';
import { InstanceLifetime } from '@cgs/wge';
import { ApplicationGameConfig } from '@cgs/shared';
import { REQUIRED_COMPONENTS_PROVIDER_TOKEN } from '@cgs/machines';
import { CorsicaGameProvider } from './corsica-game-provider';
import { CORSICA_FREE_SPINS_COUNT_COMPONENT_TOKEN } from './slot/free-spins/corsica-free-spins-count.component';
import { CorsicaFreeSpinsComponent } from './slot/free-spins/corsica-free-spins.component';
import { CorsicaHudSdkModule } from './slot/hud/corsica-hud-sdk.modules';
import {
  CORSICA_START_PAGE_COMPONENT_TOKEN,
  CorsicaStartPageComponent,
} from './slot/start-page/corsica-start-page.component';
import {
  CORSICA_BONUS_HUD_VISIBILITY_COMPONENT_TOKEN,
  CorsicaBonusHudVisibilityComponent,
} from './slot/bonus/corsica-bonus-hud-visibility.component';

const FAST_SPINS_SPEED_MULTIPLIER = 1;

export class CorsicaGameProviderTrifecta extends CorsicaGameProvider {
  public override register(): void {
    super.register();

    CorsicaHudSdkModule.register(this.container, {
      sdkAdapter: {
        gameTitle: 'Corsica',
        gameVersion: ApplicationGameConfig.appVersion,
        hasIntro: true,
        hasBuyFeatures: true,
        enableAutoReplay: false,
        isDebug: true,
      },
      gameHook: {
        machineId: 5,
        // Reel speed comes from game-config.json in every turbo mode; the
        // modes only scale the inter-reel delays (CorsicaSpinDelayFactorProvider).
        fastSpins: {
          firstSpeed: FAST_SPINS_SPEED_MULTIPLIER,
          secondSpeed: FAST_SPINS_SPEED_MULTIPLIER,
        },
      },
    });

    this.container.register(
      CORSICA_START_PAGE_COMPONENT_TOKEN,
      (container) => new CorsicaStartPageComponent(container),
      { lifetime: InstanceLifetime.Singleton }
    );

    this.container.register(
      TRIFECTA_START_PAGE_COMPONENT_TOKEN,
      (container) => container.resolve(CORSICA_START_PAGE_COMPONENT_TOKEN),
      { lifetime: InstanceLifetime.Singleton }
    );

    this.container.register(
      CORSICA_BONUS_HUD_VISIBILITY_COMPONENT_TOKEN,
      (container) => new CorsicaBonusHudVisibilityComponent(container),
      { lifetime: InstanceLifetime.Singleton }
    );

    this.container.registerValue(
      REQUIRED_COMPONENTS_PROVIDER_TOKEN,
      [CORSICA_START_PAGE_COMPONENT_TOKEN, CORSICA_BONUS_HUD_VISIBILITY_COMPONENT_TOKEN],
      { multi: true }
    );

    // TODO: trifecta sdk: replace token with TRIFECTA_FREE_SPINS_COMPONENT_TOKEN
    this.container.register(
      CORSICA_FREE_SPINS_COUNT_COMPONENT_TOKEN,
      (container) => new CorsicaFreeSpinsComponent(container),
      {
        lifetime: InstanceLifetime.Singleton,
      }
    );
  }
}
